import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const InfoIcon = ({ viewBox, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 18 18'}>
    <path
      d="M9.8 9.02002V5.30002C9.8 4.86002 9.44 4.50002 9 4.50002C8.56 4.50002 8.2 4.86002 8.2 5.30002V9.02002C8.2 9.46002 8.56 9.82002 9 9.82002C9.44 9.82002 9.8 9.46002 9.8 9.02002ZM9.7 12.34C9.88 12.16 10 11.9 10 11.64C10 11.38 9.9 11.12 9.7 10.94C9.52 10.76 9.26 10.64 9 10.64C8.74 10.64 8.48 10.74 8.3 10.94C8.12 11.12 8 11.38 8 11.64C8 11.9 8.1 12.16 8.3 12.34C8.48 12.52 8.74 12.64 9 12.64C9.26 12.64 9.52 12.52 9.7 12.34Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 16.4C13.0869 16.4 16.4 13.0869 16.4 9C16.4 4.91309 13.0869 1.6 9 1.6C4.91309 1.6 1.6 4.91309 1.6 9C1.6 13.0869 4.91309 16.4 9 16.4ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
      fill="white"
    />
  </BaseIcon>
);

export default InfoIcon;
